import { isMobileDevice } from "../../../utils/MobileDetectUtil";

export const DEVICE_CHECK_DELAY_MS = 3000;

export const getDeviceContinuation = (client) =>
  isMobileDevice(client) ? "mobile" : "desktop";
